export default "__VITE_ASSET__D6AYkz1E__"